import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

import Icon from 'shared/components/icon';

import 'stylesheets/components/account-settings-tab-button.scss';
import usePlatformContext from 'src/hooks/usePlatform';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconDefinition} from '@fortawesome/fontawesome-common-types';
import Colors from '../../../shared/aptitude/colors';

interface Props {
  children: React.ReactNode;
  active?: boolean;
  icon?: IconDefinition;
}

const Tab = ({children, active, icon}: Props) => {
  const {isIonic} = usePlatformContext();

  return (
    <div
      className={classnames('account-settings-sidebar-link', {
        'account-settings-sidebar-link-active': active,
      })}
    >
      {isIonic && icon && (
        <span className={styles.iconContainer}>
          <FontAwesomeIcon icon={icon} color={Colors.n400} className={styles.icon} />
        </span>
      )}
      <div className={classnames('account-settings-sidebar-label-name', {['no-padding']: !icon})}>
        {children}
      </div>
      <Icon iconType="chevron-right" className="account-settings-sidebar-label-icon" />
    </div>
  );
};

export default Tab;
